import { addEventParam, INinjaEvent, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import { DiscoveryCardType, KissanEventType, useProfileStore } from '@ninjacart/nc-nk-store';
import { ImageOrSvg, SizeTokens, XStack, YStack } from '@ninjacart/nc-nk-ui';
import { useRouter } from '@ninjacart/nc-nk-web-deps';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dimensions, View } from 'react-native';
import { Link } from 'solito/link';
import { VideoViewCount } from './playIconwithViewCount';

export function MachineryPlayListCard({ horizontal, cardWidth, item }) {
  const [size, setSize] = useState(0.5);
  const [progress, setProgress] = useState(30);
  const sizeProp = `$${size}` as SizeTokens;
  const screenWidth = Dimensions.get('window').width;
  const numColumns = horizontal ? undefined : Math.floor(screenWidth / cardWidth);
  const { t } = useTranslation();
  const { push } = useRouter();

  const userProfile = useProfileStore((state) => state.userProfile);
  const blurhash =
    '|rF?hV%2WCj[ayj[a|j[az_NaeWBj@ayfRayfQfQM{M|azj[azf6fQfQfQIpWXofj[ayj[j[fQayWCoeoeaya}j[ayfQa{oLj?j[WVj[ayayj[fQoff7azayj[ayj[j[ayofayayayj[fQj[ayayj[ayfjj[j[ayjuayj[';
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const navigate = () => {
    const discoveryVideoMachineryEvent: INinjaEvent = {
      name: KissanEventType.FEEDPAGE_DIS_CLICKON_VIDEOMACHINERY,
      screenDetails: { screen: 'feed page machinery play list page' },
      eventParams: [
        addEventParam('subCategory', item?.content?.name),
        addEventParam('playListId', item?.content?.playlistId),
      ],
    };
    enqueue(discoveryVideoMachineryEvent);
  };

  const videoUrl = `/playListDetail/${item?.content?.seoUrl ?? item?.content?.playlistId}?type=${DiscoveryCardType.MACHINERY}`;

  return (
    <XStack onPress={navigate} justifyContent="center" padding={8}>
      <Link href={videoUrl} shallow>
        <YStack
          width={cardWidth}
          height={130}
          position="relative"
          borderRadius={12}
          overflow="hidden"
          pressStyle={{ scale: 0.98 }}
        >
          <ImageOrSvg
            height={150}
            width={cardWidth}
            fit={'contain'}
            uri={
              item?.mediaDetails?.[0]?.mediaUrl ??
              'https://tecxprts3qa.s3.amazonaws.com/1711699423015Cattle.svg'
            }
            blurHash={blurhash}
            borderRadius={0}
          />
          <VideoViewCount item={item} />
        </YStack>
      </Link>
    </XStack>
  );
}
